import Cookies from "js-cookie";
const SupportKey='supportKey';
export function getSupport() {
  return Cookies.get(SupportKey)
}

export function setSupport(isSupport) {
  return Cookies.set(SupportKey, isSupport,{ expires: 3 })
}

export function setCookie(key,value,expires, domain) {
  console.log(expires)
  return Cookies.set(key, value,{ domain: domain, expires: expires}, domain)
}

export function getCookie(key) {
  return Cookies.get(key)
}

export function removeCookie(key,expires) {
  return Cookies.remove(key, { domain: 'pets-love.com.cn' })
}



// WEBPACK FOOTER //
// ./src/utils/support.js